import apiClient from './axios'
import api from './api'

export interface PaymentOrderRequest {
  page: number
  pageSize: number
  agentUsername?: string
  userId?: string
  ipAddress?: string
  orderNo?: string
  status?: string
  channelName?: string
  startDate?: string
  endDate?: string
  from_app?: 0 | 1 | 2
  fromApp?: 0 | 1 | 2
  isStolen?: number
  is_stolen?: number
  hasDeduction?: number
  deduction?: number
}

export interface PaymentOrderResponse {
  items: PaymentOrder[]
  total: number
  page: number
  pageSize: number
  totalPages: number
  hasNextPage: boolean
  hasPreviousPage: boolean
}

export interface PaymentOrder {
  id: string
  orderNo: string
  userId: string
  agentId: string | null
  bizType: string
  bizId: string
  currency: string
  amount: string
  basePriceCny: string
  originalCurrency: string | null
  originalAmount: string | null
  exchangeRate: string | null
  paymentPlatformId: number
  paymentChannelId: number
  paymentPlatformOrderNo: string | null
  paymentMethod: string | null
  status: string
  createdAt: string
  paidAt: string | null
  expiredAt: string | null
  notifyCount: number
  lastNotifyAt: string | null
  extra: any
  ipAddress: string | null
  deletedAt: string | null
  from_app?: 0 | 1 | 2
  fromApp?: 0 | 1 | 2 | boolean
  /** 是否扣量：1 是，0 否（接口可能返回 number / string / boolean） */
  isStolen?: number | string | boolean | null
  is_stolen?: number | string | boolean | null
  /** 是否已锁单：1 已锁（接口也可能返回 lock_order） */
  lockOrder?: number | string | boolean | null
  lock_order?: number | string | boolean | null
  productName: string
  user: {
    id: string
    display_id: string
    username: string
    nickname: string
    phone: string
    avatar: string | null
    is_visitor: boolean
    is_verified: boolean
    created_at: string
    updated_at: string
    vip_id: string
    is_bot: boolean
    country_id: string
    agent_id: string
    is_active?: boolean | string | number | null
    active?: boolean | string | number | null

    // ... other user fields
  } | null
  agent: any
  platform: {
    id: number
    name: string
    code: string
    status: string
    // ... other platform fields
  }
  channel: any
  vip?: {
    id: string
    translations?: Array<{
      id?: number | string
      lang?: string
      name?: string | null
      description?: string | null
      short_intro?: string | null
    }>
  } | null
  walletTransactions: any[]
  callbackLogs: any[]
  visitStats: any[]
  userBoughts: any[]
}

export const paymentOrderService = {
  async findAllPaymentOrders(request: PaymentOrderRequest): Promise<PaymentOrderResponse> {
    const response = await apiClient.post(api.findAllPaymentOrders(), request)
    return response.data
  }
}

export default paymentOrderService
